import { checkPrivilege } from "./net";

const ALL_PERMISSION = [
    /* header */
    'wallet.header.view',
    'subscription.header.view',
    'links.header.view',
    'user.header.view',
    'logo.header.view',
    'header.translate.view',

    /* module */
    'rodin.view',
    'omnicraft.view',
    'chatavatar.view',

    /* footer */
    'footer.rodin.view',

    /* mobile */
    'mobile.feature',

    /* index */
    'nav.index.view',

    /* index rodin */
    'wallet.index.rodin.view',
    'private.index.rodin.view',

    /* gallery rodin */
    'featured.nav.gallery.rodin.view',
    'mine.nav.gallery.rodin.view',
    'story.nav.gallery.rodin.view',
    'recent.nav.gallery.rodin.view',
    'search.rodin.view',

    /* card */
    'share.card.rodin.view',
    'private.card.rodin.view',
    'like.card.rodin.view',
    'sketchfab.card.rodin.view',

    /* billing */
    'billing.view',
    'billing.feature',

    /* auth */
    'verification.register.feature',
    'oauth.login.feature',
    'forget_password.register.feature',

    /* api */
    'api.view',
    'api.feature',

    /* other */
    'feedback.view',
    'workbench.view',
    'referral.feature',
    'rodin.onboard.view',
    'terms.view',
    'consent.view',
    'captcha.feature',
    'basic.captcha.feature',
    'control_net.feature',
    'featured.new_user_promotion',
    'featured.upgrade_modal'
];

const roles = {
    user: {
        allow: ALL_PERMISSION,
        deny: [
            'rodin.onboard.view',
            'captcha.feature',
            'workbench.view',
            'basic.captcha.feature',
            // 'omnicraft.view'
        ]
    },
    dev: {
        allow: [...ALL_PERMISSION],
        deny: [
            'rodin.onboard.view',
            'terms.view',
            'consent.view',
            'captcha.feature',
            'basic.captcha.feature',
        ]
    },
    bambu: {
        allow: ALL_PERMISSION,
        deny: [
            /* index */
            'nav.index.view',

            /* Header */
            'wallet.header.view',
            'subscription.header.view',
            'links.header.view',
            // 'user.header.view',
            'logo.header.view',

            /* index rodin */
            'wallet.index.rodin.view',
            'private.index.rodin.view',

            /* gallery rodin */
            // 'featured.nav.gallery.rodin.view',
            // 'mine.nav.gallery.rodin.view',
            'story.nav.gallery.rodin.view',
            'recent.nav.gallery.rodin.view',

            /* card */
            'share.card.rodin.view',
            'private.card.rodin.view',
            'like.card.rodin.view',
            'sketchfab.card.rodin.view',

            /* billing */
            'billing.view',
            'billing.feature',

            /* auth */
            'verification.register.feature',
            'oauth.login.feature',
            'forget_password.register.feature',

            /* api */
            'api.view',
            'api.feature',

            /* other */
            'feedback.view',
            'referral.feature',
            'rodin.onboard.view',
            'terms.view',
            'consent.view',
        ]
    },
    bytedance: {
        allow: ALL_PERMISSION,
        deny: [
            /* index */
            'nav.index.view',

            /* header */
            'wallet.header.view',
            'subscription.header.view',
            'links.header.view',
            // 'user.header.view',
            'logo.header.view',

            /* footer */
            'footer.rodin.view',

            /* mobile */
            'mobile.feature',

            /* index rodin */
            'wallet.index.rodin.view',
            'private.index.rodin.view',
            'search.rodin.view',

            /* gallery rodin */
            // 'featured.nav.gallery.rodin.view',
            // 'mine.nav.gallery.rodin.view',
            'story.nav.gallery.rodin.view',
            // 'recent.nav.gallery.rodin.view',

            /* card */
            'share.card.rodin.view',
            'private.card.rodin.view',
            'like.card.rodin.view',
            'sketchfab.card.rodin.view',

            /* billing */
            'billing.view',
            'billing.feature',

            /* api */
            'api.view',
            'api.feature',

            /* auth */
            'verification.register.feature',
            'oauth.login.feature',
            'forget_password.register.feature',

            /* other */
            'feedback.view',
            'referral.feature',
            'rodin.onboard.view',
            'terms.view',
            'consent.view',
            'captcha.feature',
            'workbench.view',
            'featured.new_user_promotion'
        ]
    },
    netease: {
        allow: ALL_PERMISSION,
        deny: [
            /* Header */
            'wallet.header.view',
            'subscription.header.view',
            'links.header.view',
            'user.header.view',
            'logo.header.view',
            'header.translate.view',
            'header.view',

            /* footer */
            'footer.rodin.view',

            /* mobile */
            'mobile.feature',

            /* index */
            // 'nav.index.view',

            /* index rodin */
            'wallet.index.rodin.view',
            'private.index.rodin.view',
            'search.rodin.view',

            /* gallery rodin */
            'featured.nav.gallery.rodin.view',
            'mine.nav.gallery.rodin.view',
            'story.nav.gallery.rodin.view',
            'recent.nav.gallery.rodin.view',
            'gallery.card.info',

            /* card */
            'share.card.rodin.view',
            'private.card.rodin.view',
            'like.card.rodin.view',
            'sketchfab.card.rodin.view',

            /* billing */
            'billing.view',
            'billing.feature',

            /* api */
            'api.view',
            'api.feature',

            /* auth */
            'verification.register.feature',
            'oauth.login.feature',
            'forget_password.register.feature',

            /* other */
            'feedback.view',
            'workbench.view',
            '3dcondition.feature',
            'referral.feature',
            'rodin.onboard.view',
            'terms.view',
            'consent.view',
            'tip.view',
            'captcha.feature',
            'featured.new_user_promotion',
            'featured.upgrade_modal'
        ]
    }
};

export const PLAN_LEVELS = {
    FREE: 'Free',
    EDUCATION: 'Education',
    CREATOR: 'Creator',
    BUSINESS: 'Business',
    ENTERPRISE: 'Enterprise',
    UNLIMITED: 'Unlimited'
};

export const PLAN_LEVEL_MAP = {
    [PLAN_LEVELS.FREE]: 0,
    [PLAN_LEVELS.EDUCATION]: 1,
    [PLAN_LEVELS.CREATOR]: 1,
    [PLAN_LEVELS.BUSINESS]: 2,
    [PLAN_LEVELS.ENTERPRISE]: 2,
    [PLAN_LEVELS.UNLIMITED]: 2
};

export const SUBSCRIPTION_PERMISSIONS = {
    // Business及以上等级的权限
    'business.feature': [PLAN_LEVELS.BUSINESS, PLAN_LEVELS.ENTERPRISE, PLAN_LEVELS.UNLIMITED],
    // Creator及以上等级的权限
    'creator.feature': [PLAN_LEVELS.CREATOR, PLAN_LEVELS.EDUCATION, PLAN_LEVELS.BUSINESS, PLAN_LEVELS.ENTERPRISE, PLAN_LEVELS.UNLIMITED],
    // 所有付费用户的权限
    'premium.feature': [PLAN_LEVELS.CREATOR, PLAN_LEVELS.EDUCATION, PLAN_LEVELS.BUSINESS, PLAN_LEVELS.ENTERPRISE, PLAN_LEVELS.UNLIMITED],
};

export const SUBSCRIPTION_PERMISSIONS_YEARLY = 'sub.yearly.feature'
export const SUBSCRIPTION_PERMISSIONS_UNLIMITED = 'sub.unlimited.feature'

export async function getPermission(role, logInfo, subscriptionsInfo) {
    const planLevel = subscriptionsInfo?.plan_level || 'Free';
    const planYearly = subscriptionsInfo?.plan_yearly || false;
    const planUnlimited = subscriptionsInfo?.plan_level === PLAN_LEVELS.UNLIMITED || false;
    let permissions = [];

    if (roles[role]) {
        if (roles[role].allow) {
            permissions = [...roles[role].allow];
        } else {
            permissions = [...ALL_PERMISSION];
        }
        if (roles[role].deny) {
            permissions = permissions.filter(perm => !roles[role].deny.includes(perm));
        }
        Object.entries(SUBSCRIPTION_PERMISSIONS).forEach(([permission, allowedPlans]) => {
            if (allowedPlans.includes(planLevel)) {
                permissions.push(permission);
            }
        });

        if (planYearly) {
            permissions.push(SUBSCRIPTION_PERMISSIONS_YEARLY);
        }
        if (planUnlimited) {
            permissions.push(SUBSCRIPTION_PERMISSIONS_UNLIMITED);
        }


        return permissions;
    } else {
        throw new Error("Role not found");
    }
}